import { IAddress } from '@/lib/schemas/Address.zod';

import { AbstractService } from './AbstractService';

type ShippingAddress = IAddress;

export class ShippingService extends AbstractService {
  async getShippingAddresses(params?: Record<string, any>): Promise<ShippingAddress[]> {
    const response = await this.get<any>(this.endpoint('shopAddresses'), params);
    const data = response as any;

    if (data?.error) {
      throw new Error(data.error?.message || 'Failed to fetch shipping addresses');
    }

    const items: ShippingAddress[] = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    this.logger.debug({ message: 'ShippingService:getShippingAddresses', count: items.length, params });
    return items;
  }

  async createShippingAddress(address: Partial<ShippingAddress>, token?: string): Promise<ShippingAddress> {
    const response = await this.post<ShippingAddress>(this.endpoint('shopAddresses'), address, { token });
    const data = (response as any) ?? response;

    this.logger.debug({ message: 'ShippingService:createShippingAddress', address, token });

    if ((data as any)?.error) {
      throw new Error((data as any).error?.message || 'Failed to create shipping address');
    }

    return data;
  }

  async getShippingProviders(params?: Record<string, any>): Promise<any[]> {
    const response = await this.get<any>(this.endpoint('shippingProviders'), {});
    const data = response as any;

    if (data?.error) {
      throw new Error(data.error?.message || 'Failed to fetch shipping providers');
    }

    const items: any[] = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    this.logger.debug({ message: 'ShippingService:getShippingProviders', count: items.length, params });
    return items;
  }

  async getShippingLocations(providerId: string, params?: Record<string, any>): Promise<any[]> {
    const response = await this.get<any>(this.endpoint('shippingProviderLocations', { providerId }), params);
    const data = response as any;

    if (data?.error) {
      throw new Error(data.error?.message || 'Failed to fetch shipping locations');
    }

    const items: any[] = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    this.logger.debug({ message: 'ShippingService:getShippingLocations', count: items.length, params, providerId });
    return items;
  }
}

export const shippingService = new ShippingService();

export default ShippingService;
